import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';
import { SimpleProjectionAssumptions } from '../../../../types/SimpleProjection';

export function useCompanySimpleProjectionAssumptions(ticker: string) {
  return useQuery<SimpleProjectionAssumptions, Error>({
    queryKey: ['companySimpleProjectionAssumptions', ticker],
    queryFn: async () => {
      const { data } = await api.get<SimpleProjectionAssumptions>('/company-simple-projection-assumptions', {
        params: { ticker },
      });
      return data;
    },
    enabled: !!ticker,
    staleTime: 4 * 60 * 60 * 1000, // 4 hours - matches backend cache
    gcTime: 8 * 60 * 60 * 1000, // Keep in cache for 8 hours
  });
}
